import { render } from "./PBXLevelList.vue?vue&type=template&id=64d2004c"
import script from "./PBXLevelList.vue?vue&type=script&lang=js"
export * from "./PBXLevelList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__